export default __webpack_public_path__ + "static/media/348.aca81f38.png";